export default __webpack_public_path__ + "css/common.bundle.css";